import { useState, useImperativeHandle, forwardRef } from 'react';
import { find, isFunction } from 'lodash';
import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import SelectField from "../../Form/SelectField/SelectField";
import Icon from "../Icon/Icon";
import "./ButtonSelect.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ButtonSelect = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className = '',
    options = [],
    label = '',
    valueKey = 'value',
    labelKey = 'label',
    styles = {
      containerStyle: {},
      selectStyle: {},
      iconStyle: {}
    },
    icon = '',
    buttonBackgroundColor = 'black',
    iconColor = 'white',
    id,
    placeholder
  } = _ref;
  const [selectedAction, setSelectedAction] = useState(null);
  const handleOnChange = val => {
    const action = find(options, act => act.value === val);
    setSelectedAction(action);
    if (isFunction(action.action)) {
      action.action(val);
      // reset ButtonSelect
      if (ref) {
        if (isFunction(ref?.setValue)) {
          ref.setValue();
        }
        ;
        if (isFunction(ref?.current?.setValue)) {
          ref.current.setValue();
        }
        ;
      }
    }
  };

  // Expose a resetValue method
  useImperativeHandle(ref, () => ({
    setValue: () => setSelectedAction(null)
  }));
  const buttonSelectClass = () => cn(`app-components-button-select-container--${buttonBackgroundColor}`, {
    'relative font-heavy-font leading-4 focus:outline-solid-offset': true,
    'app-components-button-select--remove-icon': !icon
  });
  return /*#__PURE__*/_jsxs("div", {
    className: buttonSelectClass(),
    style: styles.containerStyle,
    children: [icon && /*#__PURE__*/_jsx(Icon, {
      className: "app-components-button-select__icon absolute z-1",
      icon: icon,
      color: iconColor,
      style: styles.iconStyle,
      size: 16
    }), /*#__PURE__*/_jsx(SelectField, {
      className: className,
      id: id,
      options: options,
      searchEnabled: false,
      label: label,
      hideLabel: true,
      valueKey: valueKey,
      labelKey: labelKey,
      onChange: handleOnChange,
      placeholder: placeholder,
      style: styles.selectStyle,
      shouldSort: false,
      value: selectedAction
    })]
  });
});
ButtonSelect.propTypes = {
  /** id for reference */
  id: PropTypes.string.isRequired,
  /** className for reference */
  className: PropTypes.string,
  /** label text for SelectField */
  label: PropTypes.string,
  /** Select options */
  options: PropTypes.array,
  /** Key used for the label */
  labelKey: PropTypes.string,
  /** Key used for the value */
  valueKey: PropTypes.string,
  /** Override the inline-styles of the elements || **Not Recommended** */
  styles: PropTypes.shape({
    containerStyle: PropTypes.object,
    selectStyle: PropTypes.object,
    iconStyle: PropTypes.object
  }),
  /** placeholder text for the button */
  placeholder: PropTypes.string.isRequired,
  /** icon for the button */
  icon: PropTypes.string,
  /** button background color */
  buttonBackgroundColor: PropTypes.string,
  /** is icon required? */
  iconColor: PropTypes.string
};
ButtonSelect.displayName = 'ButtonSelect';
export default ButtonSelect;
//# sourceMappingURL=ButtonSelect.js.map